import React, { useState } from 'react'
import { ButtonCP } from 'submodules/nerit-framework-ui/common/components/button/ButtonCP'
import { ButtonSizeTP } from 'submodules/nerit-framework-ui/common/components/button/inner/ButtonSizeTP'
import { PermissionEnum } from 'submodules/nerit-aquatec-sdk/services/auth/authenticate/enums/PermissionEnum'
import { AccessControlCP } from 'app/components/access-control/AccessControlCP'
import { ParameterGroupResponseDTO } from 'submodules/nerit-aquatec-sdk/services/parameter-group/dtos/responses/ParameterGroupResponseDTO'
import { ModalParameterGroupCP } from 'modules/collection-performance/components/parameter-group/modal-parameter-group/ModalParameterGroupCP'

interface ICPProps {
    parameterGroup?: ParameterGroupResponseDTO
    buttonSize?: ButtonSizeTP
    onSave: () => void
}

export function ButtonModalParameterGroupCP(props: ICPProps): JSX.Element {

    const [isModalVisible, setIsModalVisible] = useState<boolean>(false)

    return (
        <AccessControlCP permission={PermissionEnum.ROLE_ADMIN}>
            <ButtonCP
                style={{ marginLeft: 10 }}
                onClick={() => setIsModalVisible(true)}
                icon={props.parameterGroup ? 'edit' : 'plus'}
                size={props.buttonSize}
            >
                {props.parameterGroup ? '' : 'Novo Grupo'}
            </ButtonCP>

            <ModalParameterGroupCP
                visible={isModalVisible}
                onCancel={() => setIsModalVisible(false)}
                parameterGroup={props.parameterGroup}
                onSave={() => {
                    setIsModalVisible(false)
                    props.onSave()
                }}
            />
        </AccessControlCP>
    )
}
